module.exports = __webpack_public_path__ + "static/media/HCMM037.bcf9eaf6.jpg";